export const REPORTDEFINITION = {
  SUMMARY: '09a9706e-f356-4aef-beac-6cf47c00bda3',
  ONECLICK: '11eb7337-f704-4e5e-9e55-a765cbaba2c1'
}
